export default __webpack_public_path__ + "images/selfie-man-160x160.jpg";